'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _MPPHeading = require('../../../atoms/heading/jsx/MPPHeading');

var _MPPHeading2 = _interopRequireDefault(_MPPHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'panels-card';

var PanelsCard = function (_React$Component) {
  _inherits(PanelsCard, _React$Component);

  function PanelsCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PanelsCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PanelsCard.__proto__ || Object.getPrototypeOf(PanelsCard)).call.apply(_ref, [this].concat(args))), _this), _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _MPPHeading2.default,
          { level: '3', className: ORGANISM_NAME + '__headline' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    }, _this.renderParagraph = function (paragraph, name) {
      if (paragraph && paragraph.text) {
        return _react2.default.createElement(
          'p',
          { className: ORGANISM_NAME + '__' + name },
          htmlToReactParser.parse(paragraph.text)
        );
      }
      return null;
    }, _this.renderHatchContent = function (hatchText) {
      if (hatchText) {
        return _react2.default.createElement(
          'p',
          { className: ORGANISM_NAME + '__hatch-text' },
          htmlToReactParser.parse(hatchText.text)
        );
      }
      return null;
    }, _this.renderSteps = function (cards) {
      if (cards) {
        return cards.map(function (elem, idx) {
          return _react2.default.createElement(
            'div',
            {
              key: elem.image.src,
              className: 'col-md-3 col-xs-12 ' + ORGANISM_NAME + '__card ' + ORGANISM_NAME + '__card-' + idx
            },
            _react2.default.createElement(
              'div',
              { className: ORGANISM_NAME + '__container' },
              _react2.default.createElement('div', {
                className: ORGANISM_NAME + '__thumbnail',
                style: { backgroundImage: 'url(' + elem.image.src + ')' }
              }),
              _react2.default.createElement(
                'div',
                { className: ORGANISM_NAME + '__thumbnail-detail' },
                _this.renderParagraph(elem.name, 'name'),
                _react2.default.createElement(
                  'span',
                  { className: ORGANISM_NAME + '__category' },
                  elem.category.text
                ),
                _this.renderHatchContent(elem.hatchText)
              )
            )
          );
        });
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PanelsCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          className = _props.className,
          config = _props.config;


      var stepsClasses = (0, _classnames2.default)(ORGANISM_NAME, className);

      return _react2.default.createElement(
        'section',
        { id: config.id, className: stepsClasses, 'data-building-block': 'organism' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12' },
              this.renderHeadline(content.headline),
              this.renderParagraph(content.paragraph, 'paragraph col-md-6')
            ),
            this.renderSteps(content.cards)
          )
        )
      );
    }
  }]);

  return PanelsCard;
}(_react2.default.Component);

exports.default = PanelsCard;


PanelsCard.defaultProps = {
  config: {
    id: ''
  },
  content: {
    headline: {
      text: 'Hero'
    },
    paragraph: {
      text: 'Donec vestibulum sem sem, id feugiat mauris varius nec. Pellentesque' + 'scelerisque magna porta, semper leo et, aliquam nunc. Cras fringilla nisl et' + 'ultrices placerat. Sed scelerisque aliquam mauris eu egestas.'
    },
    cards: [{
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step1.png'
      },
      name: {
        text: 'Homepage Hero'
      },
      category: {
        text: 'Headline, Video, Photo'
      },
      hatchText: {
        text: '<a href="#">See details</a>'
      }
    }, {
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step2.png'
      },
      name: {
        text: 'Homepage Hero'
      },
      category: {
        text: 'Headline, Video, Photo'
      },
      hatchText: {
        text: '<a href="#">See details</a>'
      }
    }, {
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step3.png'
      },
      name: {
        text: 'Homepage Hero'
      },
      category: {
        text: 'Headline, Video, Photo'
      },
      hatchText: {
        text: '<a href="#">See details</a>'
      }
    }, {
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business.jpg'
      },
      name: {
        text: 'Homepage Hero'
      },
      category: {
        text: 'Headline, Video, Photo'
      },
      hatchText: {
        text: '<a href="#">See details</a>'
      }
    }, {
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business-medium.jpg'
      },
      name: {
        text: 'Homepage Hero'
      },
      category: {
        text: 'Headline, Video, Photo'
      },
      hatchText: {
        text: '<a href="#">See details</a>'
      }
    }]
  },
  className: ''
};

PanelsCard.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    cards: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      image: _propTypes2.default.shape({
        src: _propTypes2.default.string.isRequired
      }),
      name: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      category: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      hatchText: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired
    })).isRequired
  }),
  className: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels-card/jsx/PanelsCard.js
// module id = 1124
// module chunks = 4